module.exports = __webpack_public_path__ + "img/xczpc.a4eb95ca.png";